<template lang="pug">
span
  a(v-for="link in field.values", :href="link[1]", target="_blank") {{link[0]}}
</template>

<script>
export default {
  name: 'Links',
  props: {
    field: Object,
  },
};
</script>

<style lang="scss" scoped>
span {
  display: contents;
}
a {
  font-size: 1rem;
  margin: 0;
  padding: 0;
  line-height: 1.3875;
  &:last-child {
    margin-bottom: 1.75rem;
  }
}
</style>
